import * as StyleFunctions from '../utilities/StyleFunctions';
import React, {useRef, useEffect} from 'react';

function App(props) {

  var thisTab = props.thisTab;
  var tabPath = props.tabPath;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var width = props.width;
  var height = props.height;
  var inputValues = props.inputValues;
  var upwardInfo = props.upwardInfo;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var whichTgt = props.whichTgt;
  var aTabKey = props.aTabKey;
  var doAScreenRef = props.doAScreenRef;
  var generalTabStyles = props.generalTabStyles;
  var clickTab = props.clickTab;
  var chains = props.chains

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, tabPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var specificTabInfo = StyleFunctions.evaluateStyleR('TABITEMCOVER', thisTab.s, tabPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, chains);
  var intTabStyle = {};
  if (aTabKey === whichTgt){
    intTabStyle = {color:generalTabStyles.sColor, backgroundColor:generalTabStyles.sBackgroundColor};
    if (generalTabStyles.sBold){
      intTabStyle.fontWeight = 600;
    }
    if (generalTabStyles.sUnderline){
      intTabStyle.textDecoration = 'underline'
    }

  }else{
    intTabStyle = {color:generalTabStyles.uColor, backgroundColor:generalTabStyles.uBackgroundColor};
    if (generalTabStyles.uBold){
      intTabStyle.fontWeight = 600;
    }
    if (generalTabStyles.uUnderline){
      intTabStyle.textDecoration = 'underline'
    }
  }
  return <div className='col-0' ref={ref1} style={{...generalTabStyles, ...intTabStyle}} onClick={clickTab(aTabKey)}>{specificTabInfo.text}</div>
}
//
export default App;
